import React from "react";
import { Link, useLocation } from "react-router-dom";
import appRoutes from "../../routes/app.routes";
import { ReactComponent as BellIcon } from "../../assets/svg/bell-icon.svg";
import { ReactComponent as ProfileSettingsIcon } from "../../assets/svg/profile-settings-icon.svg";
import { ReactComponent as ProfileSettingsIconPink } from "../../assets/svg/profile-settings-icon-pink.svg";
import { ReactComponent as PasswordSecurityIcon } from "../../assets/svg/password-security-icon.svg";
import { ReactComponent as ProfileIcon } from "../../assets/svg/profile-icon.svg";
import { ReactComponent as ProfileIconPink } from "../../assets/svg/profile-icon-pink.svg";

const CompanySidebar = (prop: any) => {
  const { pathname } = useLocation();
  const currentSubTab = pathname.split("/")[2]
    ? pathname.split("/")[2]
    : "profile-visibility";

  return (
    <div
      className={`sidebar-container setting-container sidebar-wrap tab-sidebar-wrap ${currentSubTab === "security-login" ? "security-sidebar-wrap" : ""
        }`}
      style={{ position: "inherit" }}
    >
      <div className="setting-title">
        <h2>Settings</h2>
        <span>Manage your account settings and preferences.</span>
      </div>
      <div
        className={`sidebar-menu-wraps ${currentSubTab === "notifications"
          ? "notification-sidebar"
          : currentSubTab === "security-login"
            ? "security-sidebar"
            : ""
          }`}
      >
        <ul className="setting-list">
          <li>
            <Link
              key="link_dashboard"
              to={appRoutes.candidateProfileSettings.generatePath(
                "profile-visibility"
              )}
              className={`dashboard-menu ${currentSubTab === "profile-visibility" ? "active" : ""
                }`}
            >
              <div className="icon">
                {currentSubTab === "profile-visibility" ? <ProfileIconPink /> : <ProfileIcon />}
              </div>
              <span>Profile and Visibility</span>
            </Link>
          </li>
          <li>
            <Link
              key="link_candidates"
              to={appRoutes.candidateProfileSettings.generatePath(
                "security-login"
              )}
              className={`candidate-menu ${currentSubTab === "security-login" ? "active" : ""
                }`}
            >
              <div className="icon">
                <PasswordSecurityIcon />
              </div>
              <span>Security and Login</span>
            </Link>
          </li>
          <li>
            <Link
              key="link_candidates"
              to={appRoutes.candidateProfileSettings.generatePath(
                "notifications"
              )}
              className={`candidate-menu ${currentSubTab === "notifications" ? "active" : ""
                }`}
            >
              <div className="icon">
                <BellIcon />
              </div>
              <span>Notifications</span>
            </Link>
          </li>
          <li>
            <Link
              key="link_candidates"
              to={appRoutes.candidateProfileSettings.generatePath(
                "account-preferences"
              )}
              className={`candidate-menu ${currentSubTab === "account-preferences" ? "active" : ""
                }`}
            >
              <div className="icon">
                {currentSubTab === "account-preferences" ? <ProfileSettingsIconPink /> : <ProfileSettingsIcon />}
              </div>
              <span>Account Preferences</span>
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default CompanySidebar;
